/* tslint:disable */
/* eslint-disable */
// @ts-ignore
import * as Types from '../../../../../global-graphql-types'

import { DocumentNode } from 'graphql'
import * as Apollo from '@apollo/client'
import * as ApolloReactHooks from 'utils/extendApolloHooks'
const defaultOptions = {} as const
export type CartRemoveCouponVariables = Types.Exact<{
  cartUuid: Types.Scalars['String']
}>

export type CartRemoveCoupon = {
  __typename: 'Root'
  cartRemoveCoupon: {
    __typename: 'CartRemoveCouponPayload'
    cart: {
      __typename: 'Cart'
      id: number | null
      uuid: string | null
      coupon: { __typename: 'CartCoupon'; id: number; name: string } | null
    } | null
    errors: Array<{
      __typename: 'UserError'
      key: string | null
      message: string | null
    }> | null
  } | null
}

export const CartRemoveCouponDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CartRemoveCoupon' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'cartUuid' }
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cartRemoveCoupon' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'cartUuid' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'cartUuid' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cart' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'coupon' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'errors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode
export type CartRemoveCouponMutationFn = Apollo.MutationFunction<
  CartRemoveCoupon,
  CartRemoveCouponVariables
>

/**
 * __useCartRemoveCoupon__
 *
 * To run a mutation, you first call `useCartRemoveCoupon` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCartRemoveCoupon` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cartRemoveCoupon, { data, loading, error }] = useCartRemoveCoupon({
 *   variables: {
 *      cartUuid: // value for 'cartUuid'
 *   },
 * });
 */
export function useCartRemoveCoupon(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CartRemoveCoupon,
    CartRemoveCouponVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    CartRemoveCoupon,
    CartRemoveCouponVariables
  >(CartRemoveCouponDocument, options)
}
export type CartRemoveCouponHookResult = ReturnType<typeof useCartRemoveCoupon>
export type CartRemoveCouponMutationResult =
  Apollo.MutationResult<CartRemoveCoupon>
export type CartRemoveCouponMutationOptions = Apollo.BaseMutationOptions<
  CartRemoveCoupon,
  CartRemoveCouponVariables
>
